<template>
  <section>
    <Header :indexData="indexData" :userInfo="userInfo" :keyword="keyword"></Header>
    <div class="container">
      <div class="help-menu">
        <div v-for="(item,index) in indexData.index_nav_bottom">
          <h2>{{item.name}}</h2>
          <p v-for="(item_i,index_i) in item._child">
            <a href="javascript:;" @click="changeId(item_i.id)" :class="item_i.id==id?'active':''">{{item_i.title}}</a>
          </p>
        </div>
      </div>
      <div class="help-main">
        <div class="help-tit">{{content.title}}</div>
        <div class="help-cont" v-html="content.content"></div>
      </div>
    </div>
    <Footer :indexData="indexData"></Footer>
  </section>
</template>

<script>
import Header from "../components/header";
import Footer from "../components/footer";
export default {
  components: {
    Header,
    Footer
  },
  name: "Page",
    inject: ["reload"], //注入reload方法
  data() {
    return {
      guid: "",
      indexData: {
        index_cartnum: 0,
        index_shop_self: {
          adlist: [{ url: "", src: "" }, { url: "", src: "" }]
        }
      },
      userInfo: {},
      keyword: "",
      autotroph: sessionStorage.autotroph,
      cainixihuan: {}, //猜你喜欢的数据
      id: getParameterByName("id"),
      content: {}
    };
  },
  methods: {
    changeId(id) {
      // this.id = id;
      // this.getcontentInfo();
      this.$router.push(`/page?id=${id}`);
      this.reload(); //直接调用
    },
    async getcontentInfo() {
      if (!this.id) {
        return;
      }
      this.content = await this.$fetch("index/detail", {
        body: { type: "content_info", id: this.id }
      });
      console.log("?this.contentthis.contentthis.content", this.content);
    }
  },

  async mounted() {
    let that = this;
    this.guid = sessionStorage.guid;
    if (sessionStorage.user) {
      this.userInfo = JSON.parse(sessionStorage.user);
    }
    // this.getlist();
    this.indexData = await this.$fetch("Index/indexdata");
    this.getcontentInfo();
  }
};
</script>


<style lang='scss' scoped>
.help-main {
  width: 850px;
}
</style>



// WEBPACK FOOTER //
// src/pages/page.vue